export default __webpack_public_path__ + "static/media/money.9c13bb67.svg";